import anodum from 'anodum';
import { BLOCK_SETTING_COMMENT } from '../../constants/regexp';
import extractOriginalId from './extract-original-id';
import generateIdSuffix from './generate-id-suffix';

function findComments(root) {
  const doc = root.ownerDocument;
  const treeWalker = doc.createTreeWalker(root, NodeFilter.SHOW_COMMENT);
  const comments = [];

  while (treeWalker.nextNode()) {
    const node = treeWalker.currentNode;
    const match = node.nodeValue.match(BLOCK_SETTING_COMMENT);

    if (match) {
      const [, selector, markup, blockSettingId] = match;
      const contentElement = anodum.parseElementFromString(markup);

      comments.push({ node, selector, contentElement, blockSettingId });
    }
  }

  return comments;
}

function randomizeWsElementsIds(root) {
  const doc = root.ownerDocument;
  const comments = findComments(root);

  comments.forEach(({ node, contentElement }) => {
    node.replaceWith(contentElement);
  });

  const wsElementsSelector = `
    ws-contact-form-container input[id],
    ws-contact-form-container select[id],
    ws-contact-form-container textarea[id]
  `;

  const wsElements = [...root.querySelectorAll(wsElementsSelector)];

  if (root.matches(wsElementsSelector)) {
    wsElements.push(root);
  }

  wsElements.forEach((element) => {
    const currentId = element.id;
    const originalId = extractOriginalId(currentId);
    const newId = originalId + generateIdSuffix();

    // eslint-disable-next-line no-param-reassign
    element.id = newId;

    const associatedElement = root.querySelector(`[for=${currentId}]`);

    if (associatedElement) {
      associatedElement.setAttribute('for', newId);
    }
  });

  comments.forEach(({ selector, contentElement, blockSettingId }) => {
    const comment = doc.createComment(
      `{${selector}}{false}{${contentElement.outerHTML}}{${blockSettingId}}`
    );

    contentElement.replaceWith(comment);
  });
}

export default randomizeWsElementsIds;
